import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { useAuthStore } from '../store/auth'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/LoginView.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/courses',
    component: () => import('../layouts/MainLayout.vue'),
    meta: { requiresAuth: true },
    children: [
       { path: 'overview',        component: () => import('../views/courses/OverView.vue') },
    ]
  },
    {
    path: '/apps',
    component: () => import('../layouts/MainLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      //  { path: 'kiosk/marketing-video',        component: () => import('../views/apps/KioskMarketingVideo.vue') },
    ]
  },
  {
    path: '/tickets',
    component: () => import('../layouts/MainLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'tickets',
        component: () => import('../views/tickets/TicketsView.vue')
      }
    ]
  },
  {
    path: '/user-profile',
    component: () => import(/* webpackChunkName: "main-layout" */ '../layouts/MainLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'user-profile',
        component: () => import(/* webpackChunkName: "user-profile" */ '../views/profile/UserProfile.vue')
      }
    ]
  },
    {
    path: '/profile',
    component: () => import(/* webpackChunkName: "main-layout" */ '../layouts/MainLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'profile',
        component: () => import(/* webpackChunkName: "user-profile" */ '../views/profile/Profile.vue')
      }
    ]
  },
  {
    path: '/test',
    component: () => import(/* webpackChunkName: "main-layout" */ '../layouts/MainLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'test',
        component: () => import(/* webpackChunkName: "user-profile" */ '../views/test.vue')
      }
    ]
  },
  {
    path:'/wysiwyg',
    component: () => import(/* webpackChunkName: "main-layout" */ '../layouts/MainLayout.vue'),
    meta: { requiresAuth: true, role: 'agent' },
    children: [
      {
        path: '',
        name: 'wysiwyg',
        component: () => import(/* webpackChunkName: "wysiwyg" */ '../views/editor/WysiwygEditor.vue')
      }
    ]
  },
    {
    path:'/component-controller',
    component: () => import(/* webpackChunkName: "main-layout" */ '../layouts/MainLayout.vue'),
    meta: { requiresAuth: true, role: 'agent' },
    children: [
      {
        path: '',
        name: 'component-controller',
        component: () => import(/* webpackChunkName: "component-controller" */ '../views/component_controller/ComponentController.vue')
      }
    ]
  },
  {
    path: '/forbidden',
    name: 'forbidden',
    component: () => import('../views/Forbidden.vue'),
    meta: { requiresAuth: true }
  },

  {
    path: '/:section/:pathMatch(.*)*',
    component: () => import('../layouts/MainLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'component-content',
        component: () => import('../views/components_content/ComponentContent.vue')
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('../views/NotFound.vue')
  },


]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(async (to, from, next) => {
  const auth = useAuthStore();
  
  // If route requires auth and user is not authenticated
  if (to.meta.requiresAuth !== false && !auth.isAuthenticated) {
    return next({ name: 'login' });
  }

  // If user is logged in but profile isn't loaded (e.g. after refresh), fetch it
  if (auth.isAuthenticated && !auth.user?.role) {
    await auth.fetchProfile();
  }

  // Role-based protection
  if (to.meta.role && auth.user?.role !== to.meta.role && auth.user?.role !== 'admin') {
    return next({ name: 'forbidden' });
  }

  next();
});

export default router
